import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=0d2f6df3"
import script from "./PermissionList.js?vue&type=script&lang=js&external"
export * from "./PermissionList.js?vue&type=script&lang=js&external"
import style0 from "./PermissionList.vue?vue&type=style&index=0&id=0d2f6df3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports